export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";